export default "__VITE_ASSET__131413a0__"